<template>
    <div class="tabcontent">
        <v-container :fluid="true" v-resize="onResize" ref="zayavkicontainer">
            <v-row align="center">
                <v-col cols="12" md="6" sm="6">
                    <v-btn color="primary" @click="addZayavka">Добавить</v-btn>
                    <v-btn color="primary" class="rebootFilter" title="Сбросить фильтр" @click="rebootFilter" dark>
                        <v-icon>mdi-reload</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="12" md="6" sm="6" align="right" class="rightExPd">
                  <v-btn color="blue" @click="excelList" dark>
                    <v-icon>mdi-microsoft-excel</v-icon>
                  </v-btn>
                  <v-btn color="blue" @click="pdfList" dark>
                    <v-icon>mdi-file-pdf-outline</v-icon>
                  </v-btn>


                </v-col>
            </v-row>
        </v-container>
        <v-skeleton-loader
                :loading="loading"
                type="table-tbody"
                class="mx-auto"
        >
          <template>
            <v-data-table
                :headers="headers"
                class="elevation-1"
                :items="zaiavkilist"
                :footer-props="{
                  'items-per-page-options': [50, 100, 200, 300]
                }"
                :items-per-page="50"
                @click:row="editClick"
            >
              <template v-slot:body.prepend>
                <tr>
                  <th>
                    <v-text-field
                        v-model="number"
                        @input="changeUsers"
                    ></v-text-field>
                  </th>
                  <th>
                    <v-skeleton-loader
                        :loading="loading"
                        type="list-item"
                        class="mx-auto"
                    >
                      <v-autocomplete
                          v-model="IdState"
                          :items="statelist"
                          @input="changeUsers"
                      ></v-autocomplete>
                    </v-skeleton-loader>
                  </th>
                  <th></th>
                  <th><v-text-field
                      v-model="summa"
                      @input="changeUsers"
                  ></v-text-field>
                  </th>
                  <th>
                    <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        class="mx-auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                            v-model="PlanDate"
                            persistent-hint
                            v-bind="attrs"
                            @blur="date = parseDate(PlanDate)"
                            v-on="on"
                            :dense="true"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="date" first-day-of-week="1" range no-title required></v-date-picker>
                    </v-menu>
                  </th>
                  <th>
                    <v-skeleton-loader
                        :loading="loading"
                        type="list-item"
                        class="mx-auto"
                    >
                      <v-autocomplete
                          v-model="IdUser"
                          :items="userslist"
                          @input="changeUsers"
                      ></v-autocomplete>
                    </v-skeleton-loader>

                  </th>
                  <th><v-skeleton-loader
                      :loading="loading"
                      type="list-item"
                      class="mx-auto"
                  >
                    <v-autocomplete
                        v-model="IdOrg"
                        :items="orglist"
                        @input="changeOrg"
                    ></v-autocomplete>
                  </v-skeleton-loader></th>
                  <th>
                    <v-skeleton-loader
                        :loading="loading"
                        type="list-item"
                        class="mx-auto"
                    >
                      <v-autocomplete
                          v-model="IdReceiver"
                          :items="receiverlist"
                          @input="changeUsers"
                      ></v-autocomplete>
                    </v-skeleton-loader>
                  </th>
                </tr>

              </template>
              <template v-slot:item.StateZayv="{ item }">
                {{ getStateZayav(item.StateZayv) }}
              </template>
              <template v-slot:item.PlanDate="{ item }">
                {{ item.PlanDate | toDate }}
              </template>
              <template v-slot:item.Summa="{ item }">
                {{ item.Summa | toCurrency}}
              </template>
            </v-data-table>
          </template>
          <!--
        <v-card v-show="loading === false">
            <v-simple-table class="table-cursor">
                <template>
                    <thead>
                    <tr>
                        <th>
                          <v-text-field
                              v-model="number"
                              label="№"
                              @input="changeUsers"
                          ></v-text-field>
                        </th>
                        <th>
                          <v-skeleton-loader
                              :loading="loading"
                              type="list-item"
                              class="mx-auto"
                          >
                            <v-autocomplete
                                v-model="IdState"
                                :items="statelist"
                                label="Статус"
                                @input="changeUsers"
                            ></v-autocomplete>
                          </v-skeleton-loader>
                        </th>
                        <th>Наименование работ и услуг</th>
                        <th><v-text-field
                            v-model="summa"
                            label="Сумма"
                            @input="changeUsers"
                        ></v-text-field>
                        </th>
                        <th>
                          <v-menu
                            ref="menu1"
                            v-model="menu1"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            class="mx-auto"
                          >
                          <template #activator="{ on, attrs }">
                            <v-text-field
                                v-model="PlanDate"
                                persistent-hint
                                v-bind="attrs"
                                label="Дата платежа"
                                @blur="date = parseDate(PlanDate)"
                                v-on="on"
                                :dense="true"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="date" first-day-of-week="1" range no-title required></v-date-picker>
                        </v-menu>
                        </th>
                        <th>
                          <v-skeleton-loader
                              :loading="loading"
                              type="list-item"
                              class="mx-auto"
                          >
                            <v-autocomplete
                                v-model="IdUser"
                                :items="userslist"
                                label="Заявитель"
                                @input="changeUsers"
                            ></v-autocomplete>
                          </v-skeleton-loader>

                        </th>
                        <th><v-skeleton-loader
                            :loading="loading"
                            type="list-item"
                            class="mx-auto"
                        >
                          <v-autocomplete
                              v-model="IdOrg"
                              :items="orglist"
                              label="Отправитель"
                              @input="changeOrg"
                          ></v-autocomplete>
                        </v-skeleton-loader></th>
                        <th>
                          <v-skeleton-loader
                              :loading="loading"
                              type="list-item"
                              class="mx-auto"
                          >
                            <v-autocomplete
                                v-model="IdReceiver"
                                :items="receiverlist"
                                label="Получатель"
                                @input="changeUsers"
                            ></v-autocomplete>
                          </v-skeleton-loader>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in zaiavkilist" @click="editClick(item.ID)" :key="item.ID">
                        <td>{{ item.ID }}</td>
                        <td>{{ getStateZayav(item.StateZayv) }}</td>
                        <td>
                            {{ item.Osnovanie }}
                        </td>
                        <td class="text-right">{{ item.Summa | toCurrency}}</td>
                        <td>{{ item.PlanDate | toDate }}</td>
                        <td>{{ item.NameZayavitel }}</td>
                        <td>{{ item.NameSender }}</td>
                        <td>{{ item.NameReceiver }}</td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-card>-->
        </v-skeleton-loader>
        {{errorMsg}}
    </div>
</template>

<script>

    import { bus } from '../../plugins/bus.js'

    export default {
        name: "Zaiavki",
        mounted() {
            this.$store.dispatch('GET_ORGFILTERS', {IdOrg: this.IdOrg, IdUser: this.IdUser, PlanDate: this.PlanDate, IdState: this.IdState,IdReceiver: this.IdReceiver, summa: this.summa, number: this.number, IdHouse: this.IdHouse > 0 ? this.IdHouse : -1}).then(() => {
                this.$store.dispatch('GET_ZAYAVKILIST', {IdOrg: this.IdOrg, IdUser: this.IdUser, IdReceiver: this.IdReceiver, IdState: this.IdState, PlanDate: this.PlanDate, summa: this.summa, number: this.number, IdHouse: this.IdHouse > 0 ? this.IdHouse : -1}).then(() => {
                    this.loading = false;
                }).catch(err => {
                    console.warn(err);
                    this.loading = false;
                    this.errorMsg = 'failed';
                });
            });

            bus.$on('refreshTabZaiavki', this.refreshHandler);
            bus.$on('resetFilterhTabZaiavki', this.resetfilterHandler);
        },
        beforeMount () {
            this.loadFilters();
        },
        data () {
            return {
                IdOrg: localStorage.getItem('idtsg'),
                IdHouse: '',
                IdUser: '',
                IdState: '',
                PlanDate: '',
                IdReceiver: '',
                date: [],
                summa: '',
                number: '',
                errorMsg: '',
                receiver:'',
                loading: true,
                menu1: false,
                heightTable: (window.innerHeight - 200),
                headers:[
                  {text: '№', value: 'ID'},
                  {text: 'Статус', value: 'StateZayv'},
                  {text: 'Наименование работ и услуг', value: 'Osnovanie'},
                  {text: 'Сумма', value: 'Summa'},
                  {text: 'Дата платежа', value: 'PlanDate'},
                  {text: 'Заявитель', value: 'NameZayavitel'},
                  {text: 'Отправитель', value: 'NameSender'},
                  {text: 'Получатель', value: 'NameReceiver'},
                ]
            }
        },
        computed: {
            zaiavkilist() {
                return this.$store.getters.ZAYAVKILIST ? this.$store.getters.ZAYAVKILIST.data : [];
            },
            orglist() {
                let orglist = this.$store.getters.ORGFILTERS ? this.$store.getters.ORGFILTERS.orglist : null;
                let ret = [];
                if(localStorage.getItem('idtsg')==0)
                  ret.push({value: 0, text: 'Все', key:0});
                if (orglist) {
                    if(localStorage.getItem('idtsg')>0){
                      Object.entries(orglist).forEach(([key, item]) => {
                        if(item.ID == localStorage.getItem('idtsg'))
                          ret.push({value: item.ID, text: item.Name, key:key});
                      });
                    }else{
                      Object.entries(orglist).forEach(([key, item]) => {
                          ret.push({value: item.ID, text: item.Name, key:key});
                      });
                    }

                }
                return ret;
            },
            houselist() {
                let houselist = this.$store.getters.ORGFILTERS ? this.$store.getters.ORGFILTERS.houselist : null;
                let ret = [];
               // let ret = [{value: 0, text: 'Все'}];
                if (houselist) {
                    // eslint-disable-next-line no-unused-vars
                    Object.entries(houselist).forEach(([key, item]) => {

                        ret.push({value: item.ID, text: item.Name});
                    });
                }
                //console.log(ret);
                return ret;
            },
            userslist() {

              let userslist = this.$store.getters.ORGFILTERS ? this.$store.getters.ORGFILTERS.userslist : null;
              let ret = [];
              ret.push({value: 0, text: 'Все'});
              if (userslist) {
                Object.entries(userslist).forEach(([key, item]) => {
                    ret.push({value: item.ID, text: item.Name, key:key});
                });
              }

              return ret;
            },
            receiverlist() {

            let zayavkilist = this.$store.getters.ZAYAVKILIST ? this.$store.getters.ZAYAVKILIST.data : [];
            let ret = [];
            let arkey= [];
              ret.push({value: 0, text: 'Все'});
              if (!zayavkilist.length == 0){
                Object.entries(zayavkilist).forEach(([key, item]) => {
                 // ret.push({value: item.ID, text: item.Name});
                  if(item.IdReceiver>0) {
                   ret.push({value: item.IdReceiver, text: item.NameReceiver});
                    arkey.push(key);
                  }
                });
              }
              function unique(arr) {
                let result = [];
                for (let str of arr) {
                  if (!result.includes(str)) {
                    result.push(str);
                  }
                }
                return result;
              }
              unique(ret);
              return ret;

            },

            statelist() {
              let ret = [];
              ret.push({value: 'none', text: 'Все'});
              ret.push({value: 0, text: 'Новый'});
              ret.push({value: 1, text: 'Утверждено'});
              ret.push({value: 2, text: 'Отказано'});
              ret.push({value: 3, text: 'Исполнено'});
              ret.push({value: 4, text: 'Отменено'});
              return ret;
            },

        },
        watch: {
          date () {

            this.PlanDate = this.formatDate(this.date);
            this.changeUsers();
          }
        },
        methods: {
            loadFilters: function() {
                let org = localStorage.getItem('VUE_TABS_ZAIAVKI_ORG');
                if (org) {
                    this.IdOrg = JSON.parse(org);
                }
            },
            saveFilters: function() {
                localStorage.setItem('VUE_TABS_ZAIAVKI_ORG', JSON.stringify(this.IdOrg));
            },
            editClick(item) {
                let id = item.ID;
                this.$parent.addTab('Изменить заявку - ' + id, id, 'ZayavkiAdd', {id: id, IdOrgDef: this.IdOrg});
            },
            addZayavka() {
                let newZayavkaAdd = [];
                let newZayavkaAddId,lastnewZayavkaAdd;
                newZayavkaAdd = JSON.parse(localStorage.getItem("newZayavkaAdd"));
                if(newZayavkaAdd) {
                    lastnewZayavkaAdd = newZayavkaAdd[newZayavkaAdd.length - 1];
                }
                if(newZayavkaAdd){
                  if(newZayavkaAdd.length>0) {
                    newZayavkaAddId = lastnewZayavkaAdd+1;
                  }else{
                    newZayavkaAddId = 1;
                  }
                }else{
                  newZayavkaAdd = [];
                  newZayavkaAddId = 1;
                }
                newZayavkaAdd.push(newZayavkaAddId);
                localStorage.setItem('newZayavkaAdd', JSON.stringify(newZayavkaAdd));

                let newZayav = 'newZayav' + newZayavkaAddId;
                this.$parent.addTab('Добавить заявку', newZayav, 'ZayavkiAdd', {id: 0, IdOrgDef: this.IdOrg, newZayav: newZayav});

            },
            changeOrg() {
                this.refreshHandler();
                this.saveFilters();
            },
            changeUsers() {
              this.refreshHandler();
              this.saveFilters();
            },
            changeHouse() {
                this.refreshHandler();
            },
            refreshHandler() {
                this.$store.dispatch('GET_ZAYAVKILIST', {IdOrg: this.IdOrg, IdHouse: this.IdHouse > 0 ? this.IdHouse : -1, IdUser: this.IdUser, IdState: this.IdState, PlanDate: this.PlanDate, IdReceiver: this.IdReceiver, summa: this.summa,number: this.number});
            },
            resetfilterHandler(params) {
                this.IdOrg = params.IdOrg;
                this.IdHouse = -1;
                this.IdUser = params.IdUser;
                this.IdState = params.IdState;
                this.PlanDate = params.PlanDate;
                this.IdReceiver = params.IdReceiver;
                this.summa = params.summa;
                this.number= params.number;
                this.refreshHandler();
            },
            getStateZayav(StateZayv) {
                switch (parseInt(StateZayv)) {
                    case 0:
                        return 'Новый';
                    case 1:
                        return 'Утверждено';
                    case 2:
                        return 'Отказано';
                    case 3:
                        return 'Исполнено';
                    case 4:
                        return 'Отменено';
                }
                return '9';
            },

            onResize() {
                //this.heightTable = (window.innerHeight - this.$refs.zayavkicontainer.clientHeight - 125);
            },
          formatDate (dates) {
            if (!dates) return null;
              let ret = [];
              for (let date of dates) {
                  const [year, month, day] = date.split('-');
                  ret.push(`${day}.${month}.${year}`);
              }
              return ret.join(' ~ ');
            /*const [year, month, day] = date.split('-');
            return `${day}.${month}.${year}`;*/
              //return ret;
          },

          parseDate (date) {
            if (!date) return null;

            /*const [day, month, year] = date.split('.');
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;*/
          },
          excelList(){
            this.$store.dispatch('EXCEL_ZAYAVKILIST', {IdOrg: this.IdOrg, IdHouse: this.IdHouse > 0 ? this.IdHouse : -1, IdUser: this.IdUser, IdState: this.IdState, PlanDate: this.PlanDate, IdReceiver: this.IdReceiver, summa: this.summa,number: this.number}).then(response => {
              window.open(response.data);
            });
          },
          pdfList(){
            this.$store.dispatch('PDF_ZAYAVKILIST', {IdOrg: this.IdOrg, IdHouse: this.IdHouse > 0 ? this.IdHouse : -1, IdUser: this.IdUser, IdState: this.IdState, PlanDate: this.PlanDate, IdReceiver: this.IdReceiver, summa: this.summa,number: this.number}).then(response => {
              window.open(response.data);
            });
          },
          rebootFilter() {
              this.IdOrg = localStorage.getItem('idtsg');
              this.IdHouse = '';
              this.IdUser = '';
              this.IdState = '';
              this.PlanDate = '';
              this.IdReceiver = '';
              this.summa = '';
              this.number= '';
              this.refreshHandler();
          }

        },
        filters: {
            toCurrency: function (value) {
                let formatter = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2});
                return formatter.format(value/1);
            },
            toDate: function (value) {
                if (!value) return '';
                const [year, month, day] = value.split('-');
                return `${day}.${month}.${year}`;
            }
        }
    }
</script>

<style scoped>
    .tabcontent {
        padding-top: 35px;
    }
    .table-cursor tbody tr:hover {
        cursor: pointer;
    }
    .rightExPd button{
      margin: 0px 5px;
    }
    .rebootFilter{
        margin-left: 10px;
    }
</style>